var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.80029L13.1282 10.8154C13.0331 12.3521 12.9857 13.1206 12.6005 13.673C12.41 13.9462 12.1648 14.1767 11.8804 14.3499C11.3053 14.7003 10.5354 14.7003 8.99562 14.7003C7.45387 14.7003 6.68298 14.7003 6.10743 14.3492C5.82288 14.1757 5.5776 13.9448 5.38721 13.6712C5.00213 13.1179 4.95567 12.3484 4.86277 10.8094L4.5 4.80029",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60001 4.8002H14.4M11.4334 4.8002L11.0239 3.95523C10.7518 3.39395 10.6157 3.11331 10.381 2.93828C10.329 2.89946 10.2739 2.86492 10.2162 2.83502C9.95635 2.7002 9.64447 2.7002 9.02071 2.7002C8.38129 2.7002 8.06161 2.7002 7.79741 2.84067C7.73887 2.8718 7.68299 2.90774 7.63038 2.9481C7.39299 3.13022 7.26038 3.42113 6.99517 4.00295L6.63176 4.8002",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.4003V7.80029",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.4003V7.80029",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBlack);
export default __webpack_public_path__ + "static/media/trash_black.270f2861ea5b356a0cc3cf13df64eb0a.svg";
export { ForwardRef as ReactComponent };